import { HttpApiError } from '@backmarket/http-api'
import { CreatePaymentError } from '@backmarket/nuxt-layer-payment/form/types/CreatePaymentError'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketBaseUrl } from '@backmarket/nuxt-module-marketplace/useMarketBaseUrl'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import translations from './usePaymentErrors.translations'

export default function usePaymentErrors() {
  const i18n = useI18n()
  const { openErrorToast } = useTheToast()
  const { baseUrlWithLocale } = useMarketBaseUrl('main')

  const handlePaymentErrors = (error: HttpApiError, failureUrl?: string) => {
    if (error?.type === '/errors/payment/creation/no-stock') {
      openErrorToast({
        title: i18n(translations.noStockTitle),
        content: i18n(translations.noStockDescription),
      })
    }

    if (error?.type === '/errors/payment/creation/offline-insurance-offer') {
      openErrorToast({
        title: i18n(translations.insuranceOfflineTitle),
        content: i18n(translations.insuranceOfflineContent),
      })
    }

    if (
      [
        '/errors/payment/creation/no-stock',
        '/errors/payment/creation/offline-insurance-offer',
      ].includes(error?.type)
    ) {
      throw new CreatePaymentError({
        scope: 'checkout',
        cause: error,
        message: error.message,
        type: error.type,
        redirection: {
          method: 'GET',
          link: {
            type: 'external',
            // failureUrl is used by bouygues in-store. We force the redirect to this flow specifically
            href: failureUrl ?? `${baseUrlWithLocale}/f2/cart`,
          },
        },
      })
    }

    throw error
  }

  return {
    handlePaymentErrors,
  }
}
